/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EquipmentIP from './equipment-ip';
import EquipmentIPDetail from './equipment-ip-detail';
import EquipmentIPUpdate from './equipment-ip-update';
import EquipmentIPDeleteDialog from './equipment-ip-delete-dialog';

const EquipmentIPRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EquipmentIP />} />
    <Route path="new" element={<EquipmentIPUpdate />} />
    <Route path=":id">
      <Route index element={<EquipmentIPDetail />} />
      <Route path="edit" element={<EquipmentIPUpdate />} />
      <Route path="delete" element={<EquipmentIPDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EquipmentIPRoutes;
